import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import { getIsDialogOpen, setIsOpenDialog } from "../../redux";
import { useGetStationDisplay } from "../../hooks";
import { StationDisplayTable } from "../../tables";
import { useScannerHelper } from "../../helpers";
import { PartDetailsDrawerDialog } from "../../dialogs";

import { useDisplaySSE } from "../../hooks/useDisplaySSE";
import { useDisplaysContext } from "./DisplayContextProvider";
import { StyledGridBox } from "./styles";
import { handleNewLayout } from "./helper";

const padding = 15;

const DisplayPageContent = ({ open, gridRef, _setIsOpenDialog = () => {} }) => {
  const [searchParams] = useSearchParams();
  const displayId = searchParams.get("display");

  const { data } = useGetStationDisplay(displayId);
  useDisplaySSE();

  const tables = useMemo(() => data?.tables || [], [data]);
  const fields = useMemo(() => data?.fields || [], [data]);

  const [routeId, setRouteId] = useState(null);
  const [dimensions, setDimensions] = useState({ height: 150, width: 200 });

  const { nav, defaultNav, layout, setLayout } = useDisplaysContext();
  const allowNav = defaultNav && nav;

  useEffect(() => {
    const handleGridSize = () => {
      if (gridRef.current) {
        const parent = gridRef.current;
        const height = (parent?.offsetHeight - padding * 3) / 2;
        const width = parent?.offsetWidth - padding;
        setDimensions({ height, width });
      }
    };

    handleGridSize();
    window.addEventListener("resize", handleGridSize);
    return () => window.removeEventListener("resize", handleGridSize);
  }, []);

  useEffect(() => {
    handleNewLayout({ tables, setLayout });
  }, [tables]);

  const handleSetOpen = useCallback(
    (workOrder) => {
      if (!open) _setIsOpenDialog("create-labor-ticket", workOrder);
    },
    [open, _setIsOpenDialog],
  );

  const onScan = useCallback(
    (workOrder) => handleSetOpen({ workOrder }),
    [handleSetOpen],
  );
  useScannerHelper(onScan);

  const onLayoutChange = useCallback(
    (newLayout) => setLayout(newLayout),
    [setLayout],
  );

  return (
    <>
      <GridLayout
        className="layout"
        layout={layout}
        cols={4}
        maxRows={2}
        rowHeight={dimensions.height}
        width={dimensions.width}
        isDraggable={allowNav}
        isResizable={allowNav}
        onLayoutChange={onLayoutChange}
        margin={[padding, padding]}
        containerPadding={[padding, padding]}
      >
        {tables.map((table) => (
          <StyledGridBox key={table.id} d={dimensions} p={padding}>
            <StationDisplayTable
              table={table}
              fields={fields}
              setWorkOrder={handleSetOpen}
              setRouteId={setRouteId}
              allowNav={allowNav}
            />
          </StyledGridBox>
        ))}
      </GridLayout>
      <PartDetailsDrawerDialog routeId={routeId} setOpen={setRouteId} />
    </>
  );
};

const mapStateToProps = (state) => ({
  open: getIsDialogOpen(state, "create-labor-ticket"),
});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayPageContent);
